import { Map } from 'immutable';

export const blockTextRenderMap = Map({
  unstyled: {
    element: 'div',
  },
});
